/**
 * Theme Registry
 *
 * Central registry of all available themes.
 * Export theme objects for type-safe access.
 */

import { bauhaus } from './bauhaus';
import { kinetic } from './kinetic';
import { Theme, ThemeId } from '../types';

export { bauhaus } from './bauhaus';
export { kinetic } from './kinetic';

/**
 * Theme map for runtime theme lookup
 */
export const themes: Record<ThemeId, Theme> = {
  bauhaus,
  kinetic,
};

/**
 * Get theme by ID
 */
export function getTheme(themeId: ThemeId): Theme {
  return themes[themeId];
}

/**
 * Get all available theme IDs
 */
export function getAvailableThemes(): ThemeId[] {
  return Object.keys(themes) as ThemeId[];
}
